module.exports = __webpack_public_path__ + "img/NF.d8432627.svg";